

































import { Component, Vue, Prop } from "vue-property-decorator";
import { SchedulingModule } from "@/store/modules/SchedulingModule";
import { formatDateWithWeekday, formatTime } from "@/utils/DateFormatter";
import { COLOR_GREEN, COLOR_LIGHT_ORANGE, COLOR_STANDARD_WHITE, COLOR_SURFACE_DARK } from "@/utils/colors";
import { themed, themedFill, themedFillTextColor } from "@/utils/Theme";
import { MovingTaskData } from "@/data/models/MovingTaskData";
import { SchedulingResult } from "@/data/models/SchedulingResult";

@Component
export default class AppointmentSuggestionItemComponent extends Vue {
  @Prop()
  schedulingResult!: SchedulingResult;

  @Prop()
  movingTaskData!: MovingTaskData | null;

  @Prop()
  isSelected!: boolean;

  @Prop()
  clickable!: boolean;

  get scheduledTask() {
    return this.schedulingResult.scheduledTask;
  }

  get objectiveFunctionScore() {
    return this.schedulingResult.schedulingScore?.total?.toString() ?? "";
  }

  /** The palette shade of a selected suggestion's colour in dark mode. */
  get cardColor() {
    return themedFill(this.lightCardColor);
  }

  /** Dark text on a selected suggestion's palette fill in dark mode. */
  get cardTextColor() {
    return themedFillTextColor(this.lightCardColor, "");
  }

  // TODO: Colors
  get lightCardColor() {
    return this.isSelected
      ? this.scheduledTask.wasConfirmed
        ? COLOR_GREEN
        : COLOR_LIGHT_ORANGE
      : themed(COLOR_STANDARD_WHITE, COLOR_SURFACE_DARK);
  }

  get userNickname() {
    return (
      SchedulingModule.userLookup.getUser(
        this.movingTaskData?.userId ?? this.scheduledTask.userId
      )?.nickname ?? ""
    );
  }

  get date() {
    return formatDateWithWeekday(
      this.movingTaskData?.startDate ?? this.scheduledTask.startDate
    );
  }

  get time() {
    return formatTime(
      this.movingTaskData?.startDate ?? this.scheduledTask.startDate
    );
  }

  onDeleteSuggestion() {
    this.$emit("deleteSuggestion", this.scheduledTask);
  }

  onSuggestionClicked() {
    if (this.isSelected) {
      this.$emit("appointmentSuggestionDeselected");
    } else {
      this.$emit("appointmentSuggestionSelected", this.scheduledTask);
    }
  }
}
